// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");

function encodeUrl(url) {
  return encodeURIComponent(Scalars.URL.toString(url));
}

function makeFacebookShareUrl(url) {
  return "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(Scalars.URL.toString(url));
}

function makeTwitterShareUrl(url) {
  return "https://twitter.com/intent/tweet?url=" + encodeURIComponent(Scalars.URL.toString(url));
}

function makeEmailShareUrl(url) {
  return `mailto:?subject=` + "My profile on Top Agent Network" + `&body=` + encodeURIComponent(Scalars.URL.toString(url));
}

exports.encodeUrl = encodeUrl;
exports.makeFacebookShareUrl = makeFacebookShareUrl;
exports.makeTwitterShareUrl = makeTwitterShareUrl;
exports.makeEmailShareUrl = makeEmailShareUrl;
/* Scalars Not a pure module */
